export default __webpack_public_path__ + "static/media/furniture2.3c75c760.jpeg";